import React from 'react';
import { Button } from './Button';
import '../styles/Header.css';

const base = process.env.PUBLIC_URL || '';

export function Header() {
  return (
    <header className="dabra-header">
      <a href="home/components#home" className="dabra-header-logo" aria-label="Dabra Development home">
        <img src={`${base}/images/home/logotextdark.png`} alt="Dabra Development" />
      </a>
      <nav className="dabra-header-nav">
        <a href="#home" className="dabra-header-link">Home</a>
        <a href="#diensten" className="dabra-header-link">Diensten</a>
        <a href="#projecten" className="dabra-header-link">Projecten</a>
        <Button href="#contact">Contact</Button>
      </nav>
    </header>
  );
}
